import { AbstractControl, ValidationErrors } from '@angular/forms';
import { validateEmail } from './email-utilities';
import { FormControlWarn } from './form-utilities';
import { hasPostOfficeBox } from './address-utilities';

const groupEmailValidator = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;

  if (!value) {
    return null;
  }

  return !validateEmail(value) ? { groupEmail: true } : null;
};

const addressWarningValidator = (
  control: FormControlWarn<any>,
): ValidationErrors | null => {
  const value = control.value;
  if (!value || !hasPostOfficeBox(value)) {
    return null;
  }

  return { addressWarning: true };
};

export const Validators = {
  groupEmailValidator,
  addressWarningValidator,
};
